import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import Heading from '~ComponentsImproved/Typography/Heading';
import { useI18n } from '~Hooks';
import CloseIcon from '~Assets/icons/close.svg';
import Icon from '~ComponentsImproved/Icon';
import { POSPayment } from '~reducers';

const Wrapper = styled.div<{
  active: boolean;
  statusColor: string;
}>`
  width: 216px;
  height: 56px;
  background-color: ${({ active, statusColor }) =>
    statusColor ? statusColor : active ? 'var(--colorBlueGray1100)' : 'var(--colorBlueGray1200)'};
  margin: 0 2px;
  box-sizing: border-box;
  position: relative;
  border-radius: 4px 4px 0px 0px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  transform: ${({ active }) => (active ? 'translateY(0)' : 'translateY(8px)')};
  transition: transform 0.2s ease-in-out;
`;

const CloseWrapper = styled.div``;

const statusColors = {
  PENDING: 'var(--colorUIOrange)',
  COMPLETED: 'var(--colorUIGreen)',
  FAILED: 'var(--colorUIRed)',
};

export interface Props {
  onTabClicked: () => void;
  onCloseTab: () => void;
  paymentStatus: 'PENDING' | 'FAILED' | 'COMPLETED' | undefined;
  id: number;
  isActive: boolean;
  payment: POSPayment | undefined;
}

const Tab: React.FunctionComponent<Props> = ({
  onTabClicked,
  onCloseTab,
  paymentStatus,
  id,
  isActive,
  payment,
}) => {
  const { i18n } = useI18n();
  return (
    <Wrapper
      key={id}
      active={isActive}
      statusColor={paymentStatus?.length ? statusColors[paymentStatus] : ''}
      onTouchStart={onTabClicked}>
      <Heading level={4} color="var(--colorWhite)">
        {`${i18n('OrderType.Purchase')} ${id}`}
      </Heading>
      {paymentStatus && (
        <Heading level={5} color="var(--colorWhite)">
          {paymentStatus}
        </Heading>
      )}
      {!payment && isActive && (
        <CloseWrapper onClick={onCloseTab}>
          <Icon src={CloseIcon} color="var(--colorBlueGray800)" />
        </CloseWrapper>
      )}
    </Wrapper>
  );
};

export default React.memo(Tab);
